import React, { useEffect, useState } from "react";
import { Box, DialogContent, Typography } from "@mui/material";
import { useInView } from "react-cool-inview";

import { profileApi } from "../../services/profileAPI";
import { MemberData } from "../../services/searchMembersAPI";
import { CustomDialog, CustomDialogTitle } from "../../ui";
import FeedMemberCard from "../feed/FeedMemberCard";

type ScListDialogPropsType = {
  open: boolean;
  onClose: () => void;
  userId: string;
};

function ScListDialog({ open, onClose, userId }: ScListDialogPropsType) {
  const [page, setPage] = useState(1);
  const [scList, setScList] = useState<MemberData[] | undefined>(undefined);
  const [endOfPagination, setEndOfPagination] = useState(false);

  const [
    trigger,
    { isFetching: superConnectionsFetching, isError: superConnectionsError },
  ] = profileApi.useLazyGetAllSuperConnectionsQuery();

  const getScList = async (page = 1, reset = false) => {
    try {
      const list: any = await trigger({ page, otherUserId: userId }).unwrap();
      if (list.length) {
        if (reset) {
          setScList(list);
        }
        const listOfSc = Array.isArray(scList) ? scList : [];
        setScList([...listOfSc, ...list]);
      } else {
        setEndOfPagination(true);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getScList(1, true);
  }, []);

  const onEndReached = async () => {
    if (superConnectionsFetching || endOfPagination) {
      return;
    }
    const nextPage = page + 1;
    await getScList(nextPage);
    setPage((p) => p + 1);
  };

  const { observe } = useInView({
    // For better UX, we can grow the root margin so the data will be loaded earlier
    rootMargin: "50px 0px",
    // When the last item comes to the viewport
    onEnter: async ({ unobserve }) => {
      // Pause observe when loading data
      unobserve();
      // Load more data
      await onEndReached();
    },
  });
  return scList?.length! > 0 ? (
    <CustomDialog
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      fullWidth={true}
      maxWidth="sm"
      open={open}
      onClose={onClose}
    >
      <CustomDialogTitle onClose={onClose}>
        <Typography>followers</Typography>
      </CustomDialogTitle>
      <DialogContent sx={{ height: "50vh", overflow: "auto" }} dividers>
        {scList?.map((member, index) => {
          const { _id, headline, image, name, isVip } = member;
          return (
            <Box
              key={_id}
              ref={index === scList.length - 1 ? observe : null}
              sx={{ mt: index === 0 ? -2 : 0 }}
            >
              <FeedMemberCard
                memberId={_id}
                name={name}
                image={image}
                headline={headline}
                from="search"
                showScButton={false}
                isVip={isVip}
              />
            </Box>
          );
        })}
      </DialogContent>
    </CustomDialog>
  ) : null;
}

export default ScListDialog;
